import { userInfoServer } from '@/api/user'
import { setSessionKey, getSessionKey } from '@/assets/js/util'

const state = {
    userInfo: {}
}

const getters = {
    userInfo: (state) => state.userInfo
}

const mutations = {
    UPDATE_USER_INFO: (state, data) => {
        state.userInfo = data
        setSessionKey({
            ...(data || {})
        })
    }
}

const actions = {
    // 更新课程信息
    async getUserInfo({ commit }) {
        const { code, data } = await userInfoServer()

        if (code === 0) {
            commit('UPDATE_USER_INFO', {
                ...getSessionKey(),
                ...data
            })
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
